<template>
  <div class="tree-view-class">
    <erpTreeSelect
      ref="treeViewRef"
      v-bind="selectConfig"
      v-on="$listeners"
    >
      <!-- 不带参数插槽 -->
      <template v-for="slot in slots.keys" :slot="slot">
        <slot :name="slot" />
      </template>
      <!-- 带参数插槽 -->
      <template v-for="scopedSlots in scopedSlots.keys" :slot="scopedSlots" slot-scope="scope">
        <slot :name="scopedSlots" v-bind="scope" />
      </template>
    </erpTreeSelect>
  </div>
</template>
<script>
// https://vue-treeselect.js.org vue-treeselect 文档

export default {
  name: 'treeView',
  components: {},
  // model: {},
  props: {},
  data () {
    return {
      treeData: [],
      defaultConfig: {
        placeholder: '请选择',
        noChildrenText: '无子节点数据',
        noResultsText: '暂无匹配数据'
      },
    };
  },
  watch: {},
  computed: {
    slots () {
      return {
        keys: Object.keys(this.$slots),
        value: Object.values(this.$slots)
      }
    },
    scopedSlots () {
      return {
        keys: Object.keys(this.$scopedSlots),
        value: Object.values(this.$scopedSlots)
      }
    },
    selectConfig () {
      let config = { ...this.defaultConfig, ...this.$attrs };
      config['always-open'] = true;
      config.appendToBody = false;
      if (this.$common.isEmpty(config['alwaysOpen'])) {
        delete config.alwaysOpen;
      }
      if (this.$common.isEmpty(config['append-to-body'])) {
        delete config['append-to-body'];
      }
      return config;
    },
  },
  created () {},
  mounted () {},
  methods: {
    messageTreeNormalizer () {
      return {};
    },
    changeMessageFolder () {}
  }
};
</script>
<style lang="less" scoped>
.tree-view-class {
  position: relative;
  :deep(.vue-treeselect) {
    position: relative;
    font-size: 14px;
    overflow: auto;
    .vue-treeselect__control{
      display: none;
      height: 0;
      overflow: hidden;
    }
    .vue-treeselect__menu-container{
      position: relative;
      top: initial;
    }
    .vue-treeselect__menu{
      position: relative;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      max-height: none !important;
      border: none;
      box-shadow: none;
    }
    .vue-treeselect__option-arrow{
      width: 12px;
      height: 12px;
    }
  }
}
</style>
